export default __webpack_public_path__ + "static/media/new-article-bottom-pink.79b3b7ec.svg";